import { Component, Input } from '@angular/core';
import { SectorService } from '../../../../core/services/sector/sector';
import { LayoutService } from '../../../../core/services/layout/layout';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Sector } from '../../../../core/models/sector.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { SectorForm } from '../sector-form/sector-form';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { AsyncPipe } from '@angular/common';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-sector-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
    TermPipe,
  ],
  templateUrl: './sector-list.html',
  styleUrl: './sector-list.scss',
})
export class SectorList {
  public page = 1;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  limit = 10;
  total = 0;
  termKey = TermKey;
  sectors: Sector[] = [];
  asyncSector!: Observable<Sector[]>;
  selectedSector: Sector | null = null;
  showColumns: string[] = ['acciones', 'id', 'name', 'objective', 'risk', 'component'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private sectorService: SectorService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Sectores');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchSector(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchSector(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncSector = this.sectorService.getSector(params).pipe(
      tap((data) => {
        this.sectors = data.results;
        this.sectorService.setSector(data.results[0]);
        this.sectorService.setSectors(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createSector() {
    this.sectorService.removeSectorSelected();
    const dialogRef = this.dialog.open(SectorForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchSector(this.page);
    });
  }

  updateSector(sector: Sector) {
    this.sectorService.setSector(sector);
    const dialogRef = this.dialog.open(SectorForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchSector(this.page);
    });
  }

  eliminate(sector: Sector): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${sector.name}?`);
    if (!confirmed) return;
    this.sectorService.delete(sector.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchSector(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
